'use strict';

const productHelpers = require('../product/productHelpers');

const SELECTORS = {
    swatchWrp: '.js-swatch-color',
    swatches: '.js-swatch-image',
    productTile: '.js-tile',
    imageContainer: '.js-tile-image',
    secondaryImage: '.js-tile-image-secondary',
    imageContainerUrl: '.js-tile-url',
    priceContainer: '.js-product-price',
    promoContainer: '.js-promo-storefront',
    slickSlide: '.slick-slide',
    slickSlideActive: '.slick-slide.slick-active'
};

/**
 * SwatchSelector class that handles the swatch color selection
 */
class SwatchSelector {
    constructor(element) {
        this.element = element;
        this.productTile = element.closest(SELECTORS.productTile);
        this.imageContainer = this.productTile.find(SELECTORS.imageContainer).eq(0);
        this.imageContainerUrl = this.productTile.find(SELECTORS.imageContainerUrl).eq(0);
        this.swatchSrc = element.attr('data-image');
        this.swatchAlt = element.attr('alt');
        this.swatchTitle = element.attr('title');
        this.swatchImgAlt = element.attr('data-img-alt');
        this.swatchSecondaryImg = element.attr('data-swatch-secondary-img') || '';
        this.href = element.closest('a').attr('href');
        this.priceObj = element.attr('data-price-obj');
        this.promoStorefront = element.attr('data-promo-storefront');
        this.swatches = this.productTile.find(SELECTORS.swatches);
        this.firstSwatch = $(this.productTile).find('.js-wishlist-slider--selected').length > 0 ? $(this.productTile).find('.js-wishlist-slider--selected') : this.swatches.first();
        this.swatchesWrp = this.productTile.find(SELECTORS.swatchWrp);
        this.priceContainer = this.productTile.find(SELECTORS.priceContainer).eq(0);
        this.initEvents();
    }

    initEvents() {
        this.element.on('click', this.onSwatchClick.bind(this));
        this.enableKeyboardInteraction();
        this.swatchesWrp.removeClass('selected');
        this.firstSwatch.closest(SELECTORS.swatchWrp).addClass('selected');
        if (!this.swatchesWrp.closest(SELECTORS.slickSlide).length || this.swatchesWrp.closest(SELECTORS.slickSlideActive).length) {
            this.swatchesWrp.removeAttr('aria-current aria-hidden tabindex').removeClass('js-no-focus');
            this.firstSwatch.closest(SELECTORS.swatchWrp).attr({
                'aria-current': 'true',
                'tabindex': '-1'
            }).addClass('js-no-focus');
        }
        if (this.element.is(this.firstSwatch)) {
            this.updateFirstSwatchAttributes();
            this.updateFirstSwatchPrice();
        }
    }

    /**
     * Enables keyboard interaction on swatches (Enter/Space)
     */
    enableKeyboardInteraction() {
        this.element.closest('a').on('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                this.onSwatchClick(e);
            }
        });
    }

    /**
     * Handles the swatch click, updates the selected state, and changes the image attributes
     */
    onSwatchClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.swatchesWrp.removeClass('selected');
        this.element.closest((SELECTORS.swatchWrp)).addClass('selected');
        if (!this.swatchesWrp.closest(SELECTORS.slickSlide).length || this.swatchesWrp.closest(SELECTORS.slickSlideActive).length) {
            this.swatchesWrp.removeAttr('aria-current aria-hidden tabindex').removeClass('js-no-focus');
            this.element.closest((SELECTORS.swatchWrp)).attr({
                'aria-current': 'true',
                'tabindex': '-1'
            }).addClass('js-no-focus');
        }
        this.updateImageAttributes();
        this.updatePrice();
        this.updatePromoStorefront();
    }
    /**
     * Updates the image container with the selected swatch's attributes
     */
    updateImageAttributes() {
        this.imageContainer.attr({
            src: this.swatchSrc,
            alt: this.swatchImgAlt,
            'data-secondary-img': this.swatchSecondaryImg
        });
        this.imageContainerUrl.attr({
            href: this.href
        });
        if (window.isDesktop) {
            if (this.swatchSecondaryImg) {
                this.productTile.find(SELECTORS.secondaryImage).eq(0).attr('src', this.swatchSecondaryImg);
            }
            this.imageContainer.trigger('swatchSelector:imageChange');
        }
    }

    /**
     * Updates price template with selected swatch's attribute
     */
     updatePrice() {
        const price = JSON.parse(this.priceObj || 'null');
        const $priceContainer = this.productTile.find(SELECTORS.priceContainer).eq(0);
        if (price && price.renderedPrice) {
            $priceContainer.replaceWith(price.renderedPrice);
        }
    }

    /**
     * Updates promo storefront label with selected swatch's attribute
     */
    updatePromoStorefront() {
        let promo = this.promoStorefront;
        const $promoContainer = this.productTile.find(SELECTORS.promoContainer).eq(0);
        promo = productHelpers.handlePromoStorefrontValue(promo) ? promo : null;
        if(!promo || promo == 'null'){
            $promoContainer.text('').addClass('d-none');
        } else{
            $promoContainer.text(promo).removeClass('d-none');
        }
    }

    /**
     * Updates the first swatch image container with the selected swatch's attributes
     */
    updateFirstSwatchAttributes() {
        this.imageContainer.attr({
            src: this.firstSwatch.attr('data-image'),
            alt: this.firstSwatch.attr('data-img-alt'),
            'data-secondary-img': this.firstSwatch.attr('data-swatch-secondary-img') || ''
        });
        this.imageContainerUrl.attr({
            href: this.firstSwatch.closest('a').attr('href')
        });
    }

    /**
     * Updates the first swatch price template with the selected swatch's attribute
     */
    updateFirstSwatchPrice() {
        var price = JSON.parse(this.firstSwatch.attr('data-price-obj'));
        if (price && price.renderedPrice) {
            this.priceContainer.replaceWith(price.renderedPrice);
        }
    }

}

module.exports = {
    initializeClass: function ($container) {
        var $root = $container ? $container : $(document);
        // Skip swatches inside a carousel Slick hasn't initialized yet: binding now
        // and having Slick rebuild the slide afterwards silently drops the handler.
        // sliders.js re-calls initializeClass($slider) right after its own Slick
        // init (mirroring einsteinCarousel.js), so these are picked up then instead.
        $root.find(SELECTORS.swatches + ':not(.js-swatch-initialized)').filter(function () {
            var $slider = $(this).closest('.js-slider');
            return !$slider.length || $slider.hasClass('slick-initialized');
        }).each((index, element) => {
            $(element).addClass('js-swatch-initialized');
            new SwatchSelector($(element));
        });
    }
};
